<template>
<div class=" row">
  <div class="col-12 row">
      <div class="row ">
          <div class="col-3 d-flex text-left justify-content-sm-between flex-wrap ">
            <label class="texto-responsivo">Tolerancia:</label>
             <input min='5' max='15' v-model="payload.toleranciaClt"  type="number" class="form-control" />
          </div>        
      </div>
  </div>
    <div class="col-12 row">
      <div class="offset-10 col-2 mt-2">
        <base-button type="success" class="animation-on-hover"
         @click="salvar()"
         >Salvar</base-button>
      </div>
    </div>
</div>
</template>
<script>
import { BaseInput } from "../../components/index";
import { Select, Option } from "element-ui";

export default {
  name: "FormTolerancia",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
  },
  props: {
    posto: "",
    parametros: "",
    isLoading: false
  },
  data() {
    return {
      payload: {
        setDB: "",
        toleranciaClt: ""
      }
    };
  },
  mounted() {
    this.carregarTolerancia();
     
    
  },
  methods: {
     carregarTolerancia(){
      
      if(this.parametros){
         this.payload.toleranciaClt = this.parametros.toleranciaClt;
      }
     },
    salvar(){
       this.payload.setDB = this.$cookies.get("db");
       this.$emit("salvarTolerancia", this.payload);
    },
  },
  watch: {
    nome() {
      this.payload.razao_social = String(
        this.payload.razao_social
      ).toUpperCase();
    },
    email() {
      this.payload.email = String(this.payload.email).toLowerCase();
    },
  }
  
};
</script>
<style>
.texto-responsivo {
   padding: 5px;
   font-size: clamp(1rem, 2.5vw, 2rem);
}

</style>